export const parseJwtToken = (token: string | null): Record<string, any> => {
    if (!token) return {}

    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (error) {
        console.error("Failed to decode ID token:", error);
        return {};
    }
};

/**
 * Generates a short numeric representation of a token.
 *
 * @param token - The token as a string.
 * @returns A numeric hash of the token, modded by 10000.
 *
 * @example
 * const token = "exampleToken";
 * const shortToken = getShortToken(token);
 * console.info(shortToken); // e.g., 1234
 */
export const getShortToken = (token: string) => {
    return token.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) % 10000;
};

/**
 * Converts a Unix timestamp to a locale string.
 *
 * @param timestamp - The Unix timestamp in seconds.
 * @returns A locale string representation of the timestamp, or "undefined" if no timestamp is provided.
 *
 * @example
 * const timestamp = 1672531200;
 * const localeString = timestampToLocaleString(timestamp);
 * console.info(localeString); // e.g., "1/1/2023, 12:00:00 AM"
 */
export const timestampToLocaleString = (timestamp?: number) => {
    if (!timestamp) return "undefined";

    return new Date(timestamp * 1000).toLocaleString();
}
